import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../utill/validation";
import { Collapse, Row, Space } from "antd";
import axios from "axios";
import api from "../config.json";
import Table from "../Common/table";
import dateTime from "../utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../utill/Excelimport";
import Loading from "../utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import _ from "lodash";
import Operation from "antd/lib/transfer/operation";
import { Content } from "antd/es/layout/layout";

const DisPatch_Section = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({
    path: "PartID",
    order: "asc",
  });
  const history = useHistory();
  const [size, setSize] = useState("lg");
  const [opStatus, setopStatus] = useState("");
  const [Inputdata, setInputData] = useState({});
  const [modelState, setmodelState] = useState(false);
  const [modelState1, setmodelState1] = useState(false);

  const [Update, setUpdate] = useState({});
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [VendorList, setVendorList] = useState([]);

  const [RMStorageList, setRMStorageList] = useState([]);

  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });

  const [rows, setRows] = useState([]);
  const [errors1, setErrors1] = useState({});
  const [errors, seterrors] = useState({});
  const [inputData, setinputData] = useState({
    PrintType: false,
    From: new Date(),
    Till: new Date(),
  });
  const [QRCodeVisible, setQRCodeVisible] = useState(false);
  const [RMlist, setRMlist] = useState([]);
  const [PdfData, setPdfData] = useState([]);
  const [QRCodeArray, SetQRCodeArray] = useState([]);
  const [EnableAllPdf, SetEnableAllPdf] = useState(false);
  const [AdjustedQty, setAdjustedQty] = useState([]);
  const [PrintType, setPrintType] = useState("All");

  const [RMIdList, setRMIdList] = useState([]);
  const [UnitOfMeasurment, setUnitOfMeasurment] = useState("");

  const [Type, setType] = useState("");
  const [Quantity, setQuantity] = useState("");

  const [BatchCode, setBatchCode] = useState("");

  const [Remarks, setRemarks] = useState("");
  const [RawMaterialData, setRawMaterialData] = useState([]);

  const [NumOfPackings, setNumOfPackings] = useState(1);
  const [formData, setFormData] = useState({});
  const [Date1, setDate] = useState([]);
  const [spareList, setspareList] = useState([]);
  const { Panel } = Collapse;
  function callback(key) {
    console.log(key);
  }
  console.log(PdfData, "vhfvhdfvbhbvd");
  const handelOnPDfEnable = (e, input) => {
    let data = [...RawMaterialData];

    if (e.currentTarget.checked) {
      // Enable the PDF and add it to the list if not already present
      const exists = data.some((item) => item._id === input._id);

      if (!exists) {
        const updatedInput = { ...input, Enable: true }; // Avoid mutating input
        data.push(updatedInput);
      } else {
        data = data.map((item) =>
          item._id === input._id ? { ...item, Enable: true } : item
        );
      }

      SetEnableAllPdf(true); // Set "EnableAllPdf" to true
    }
    if (!e.currentTarget.checked) {
      data = data.map((item) => {
        console.log("jhveffj", item._id === input._id, item, input);
        return item._id === input._id ? { ...item, Enable: false } : item;
      });
    }
    setRawMaterialData(data);
    console.log(e.currentTarget.checked, "sdhbsdfusd", data);
    setPdfData(data);
  };
  const handelSelectAll = (e) => {
    const isChecked = e.currentTarget.checked;

    // Update the RawMaterialData with updated 'Enable' values
    const updatedList = RawMaterialData.map((one) => ({
      ...one,
      Enable: isChecked,
    }));

    // Update state
    setRawMaterialData(updatedList);
    setPdfData(updatedList);
    SetEnableAllPdf(isChecked);
  };

  const columns = [
    {
      key: "select",
      label: (
        <input
          type="checkbox"
          onChange={handelSelectAll}
          checked={
            RawMaterialData.filter(
              (one) => one.Enable == false || one.Enable == undefined
            ).length > 0
              ? false
              : true
          }
        />
      ),
      content: (obj) => (
        <input
          type="checkbox"
          checked={obj["Enable"]}
          onChange={(e) => handelOnPDfEnable(e, obj)}
        />
      ),
    },
    {
      path: "ActivatedAt",
      label: "Date / Time",
      content: (obj) => (
        <label>{obj.ActivatedAt
          && moment(obj.ActivatedAt
          ).format("DD-MM-YY / hh:mm a")}</label>
      ),
    },
    { path: "Kneader_ID", label: "Kneader", content: (obj) => <label>{obj.Kneader_ID || '-'}</label> },
    { path: "MixingMill", label: "Mixer", content: (obj) => <label>{obj.MixingMill || '-'}</label> },
    {
      path: "CompoundCode",
      label: "Compound Code",
    },
    { path: "BatchCode", label: "Batch Code" },
    {
      path: "From_SrNo",
      label: "Sheet Serial",
      content: (obj) => (
        <label>{`${obj.From_SrNo}`}</label>
      ),
    },
    { path: "UniqueID", label: "QR Unique ID" },
    { path: "QtyProduced", label: "Produced Qty (kg)" },

    {
      path: "Printed",
      label: "Print Status",
      content: (obj) => <label>{`${((obj.Printed == true ? 'Yes' : 'No')) ?? 'No'}`}</label>,
    },
    // { path: "Stage", label: "Stage" },

    // {
    //   path: "createdAt",
    //   label: "Created Date1",
    //   content: (obj) => (
    //     <React.Fragment>
    //       <label>{dateTime.getStringOfDateTime(obj.createdAt)}</label>
    //     </React.Fragment>
    //   ),
    // },
    // {
    //   path: "updatedAt",
    //   label: "Last Updated Date1",
    //   content: (obj) => (
    //     <React.Fragment>
    //       <label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label>
    //     </React.Fragment>
    //   ),
    // },
    // {
    //   key: "view",
    //   content: (user) => (
    //     <button
    //       disabled={
    //         !getRightsForAccess("DynamicDataRights", RightName, "update")
    //       }
    //       onClick={() => {
    //         console.log(user, "View clicked");
    //         setUpdate(user);
    //         setopStatus("view");
    //         const UnitOfMeasurement = _.find(templateList, {
    //           RM_ID: user.RM_ID,
    //         });
    //         if (UnitOfMeasurement) {
    //         }
    //         if (UnitOfMeasurement?.UnitOfMeasurement) {
    //           setUnitOfMeasurment(UnitOfMeasurement.UnitOfMeasurement);
    //         } else {
    //           console.warn(
    //             "UnitOfMeasurement is not available in filteredMeasurmentUnit."
    //           );
    //         }
    //       }}
    //       className="btn btn-sm btn-primary"
    //     >
    //       <FontAwesomeIcon icon={faEye} />
    //     </button>
    //   ),
    // },
    // {
    //   key: "update",
    //   content: (user) => (
    //     <button
    //       disabled={
    //         !getRightsForAccess("DynamicDataRights", RightName, "update")
    //       }
    //       onClick={() => {
    //         console.log(user, "Edit clicked");
    //         setUpdate(user);
    //         setopStatus("update");
    //       }}
    //       className="btn btn-sm btn-primary"
    //     >
    //       <FontAwesomeIcon icon={faEdit} />
    //     </button>
    //   ),
    // },
  ];

  useEffect(() => {
    if (opStatus == "view" || opStatus == "update") {
      setRows(Update.checkpoints);
      setQRCodeVisible(true);
      setInputData(Update);
      setmodelState(true);
    } else {
      setRows([]);
    }
  }, [opStatus]);

  console.log(Update, "wkhfwehkf");
  useEffect(() => {
    Heading("Activated Sheet (QR)");
    getRMTypeMaster();
    getVendorMaster();
    getRMStorageMaster();
    RawMatreialMaster();
  }, []);
  const getVendorMaster = () => {
    axios
      .get(api.api + "vendor")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.Vendor,
          value: one.Vendor,
        }));
        setVendorList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getRMStorageMaster = () => {
    axios
      .get(api.api + "rmStorageWater")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.StorageLocation,
          value: one.StorageLocation,
        }));
        setRMStorageList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSetPrintTrue = (data) => {
    // Filter and map to create an array of enabled IDs
    const obj = {};
    const IdList = data
      .filter((one) => one.Enable) // Filter only items where `Enable` is true
      .map((one) => ({ _id: one._id })); // Map to objects with `_id` key
    obj["Type"] = "Activate";
    obj["IdList"] = IdList;
    // Make the API call
    axios
      .patch(`${api.api}setPrintFieldToTrue`, obj) // Use template literals for cleaner concatenation
      .then((result) => {
        console.log("API call successful:", result);
        RawMatreialMaster(); // Assuming this function refreshes the data
      })
      .catch((err) => {
        console.error("Error making API call:", err); // Use `console.error` for logging errors
      });
  };

  const getRMTypeMaster = () => {
    axios
      .get(api.api + "RMMaster")
      .then((result) => {
        const data = _.uniqBy(result.data, "RM_Type");
        const list = data.map((one) => ({
          Name: one.RM_Type,
          value: one.RM_Type,
        }));
        setTemplateList(list);
        setRMlist(data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const RawMatreialMaster = () => {
    axios
      .patch(api.api + "ActivatedGreenSheets", inputData)
      .then((result) => {
        if (result.data.length > 0) {
          const sortedData = [...result.data].sort((a, b) =>
            b.updatedAt.localeCompare(a.updatedAt)
          );

          // Update the state with sorted data
          setRawMaterialData(sortedData);
        } else {
          swal("No data available");
          setRawMaterialData([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleGetData = (value) => {
    axios
      .patch(api.api + "ActivatedGreenSheets", inputData)
      .then((result) => {
        if (result.data.length > 0) {
          setRawMaterialData(result.data);
        } else {
          swal("No data available");
          setRawMaterialData([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const filterdata = (value) => {
    axios
      .patch(api.api + "ActivatedGreenSheets", { PrintType: value })
      .then((result) => {
        setRawMaterialData(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const downloadPDF = async (qrCodeGroups, Inputdata) => {
    console.log(qrCodeGroups, Inputdata, "correct download function data");

    // Create a new PDF with B5 dimensions
    const pdf = new jsPDF("p", "mm", "b5");

    for (let i = 0; i < qrCodeGroups.length; i++) {
      // Get the current page element
      const page = document.getElementsByClassName("a4-page")[i];
      if (!page) {
        console.error(`Page element at index ${i} not found.`);
        continue;
      }

      // Convert the HTML page to a canvas
      const canvas = await html2canvas(page);

      // Convert the canvas to an image
      const imgData = canvas.toDataURL("image/png");

      // Get image properties and calculate aspect ratio
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth(); // B5 width in mm
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width; // Maintain aspect ratio

      // Add the image to the PDF
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      // Add a new page unless it's the last one
      if (i < qrCodeGroups.length - 1) {
        pdf.addPage();
      }
    }

    // Save the PDF file with a specific name
    pdf.save("ActivationSticker.pdf");

    // Close the modal after downloading
    if (typeof handleCloseModel1 === "function") {
      handleCloseModel1();
    } else {
      console.warn("handleCloseModel1 function is not defined.");
    }
  };


  const A4Sheet = (QRCodeVisible, Inputdata) => {
    // Split the QR codes into groups of 4
    const qrCodeGroups = [];
    const stickersPerPage = 16; // 4x4 grid on each page
    if (QRCodeVisible) {
      const totalStickers = Number(NumOfPackings);
      // const stickersPerPage = 9; // 3x3 grid on each page
      for (let i = 0; i < totalStickers; i += stickersPerPage) {
        qrCodeGroups.push(
          [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
            (_, j) => i + j
          )
        );
      }
    }

    // Prepare the QR Code value to display in each QRCodeSVG
    const QrCode = `CC : ${Inputdata.RM_Type};BN : ${Inputdata.InvoiceNo
      };TC : ${Inputdata.TestReportNo};
    MD : ${moment(Inputdata.InvoiceDate).format("DD-MM-YY hh:mm")};
    ED : ${moment(Inputdata.ExpiryDate).format("DD-MM-YY hh:mm")};
    Qty : ${Inputdata.Qty}; RollerNumber : ${Inputdata.RollerNumber}`;

    return (
      <div>
        {opStatus === "view" && (
          <Button
            type="primary"
            onClick={() => downloadPDF(qrCodeGroups, Inputdata)}
            style={{ marginBottom: "16px" }}
          >
            Download as PDF
          </Button>
        )}

        <div className="a4-sheet-scrollable">
          {qrCodeGroups.map((group, pageIndex) => (
            <div
              className="a4-page"
              key={pageIndex}
              style={{ pageBreakAfter: "always" }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: `repeat(${Math.sqrt(
                    stickersPerPage
                  )}, 1fr)`, // 3 columns in each row
                  gridTemplateRows: `repeat(${Math.sqrt(
                    stickersPerPage
                  )}, auto)`, // 3 rows per page (auto height)
                  gap: "35px", // Optional: Adjust the gap between items as needed
                  justifyItems: "center",
                  alignItems: "center",
                }}
              >
                {group.map((index) => (
                  <div
                    className="d-flex flex-column justify-content-center align-items-center"
                    key={index}
                    style={{ textAlign: "center" }}
                  >
                    <QRCodeSVG value={QrCode} level={"L"} size={90} />{" "}
                    {/* Adjust the size of the QR code */}
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >
                      {Inputdata.RM_Type}
                    </p>
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >
                      {Inputdata.InvoiceNo}
                    </p>
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >{`${index + 1} / ${NumOfPackings}`}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const handleSort = (sortColumn) => {
    if (RawMaterialData.length > 0) {
      const sorted = _.orderBy(
        RawMaterialData,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);

      setRawMaterialData(sorted);
    }
  };
  const handleCloseModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleHideModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleCloseModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const handleHideModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const schema = {
    InvoiceNo: joi.string().required(),
    RM_Type: joi.string().required(),
    TestReportNo: joi.string().required(),
    InvoiceDate: joi.string().required(),
    ExpiryDate: joi.string().required(),
    Qty: joi.number().required(),
    NumOfPackings: joi.number().required(),
    _id: joi.string(),
  };

  const handleOnChange = (name, value) => {
    setinputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const downloadExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with headers only
    const headers = getColumnsWithoutUserInput(selectedTemplate.Columns).map(
      (column) => column.DbFieldName
    );
    headers.unshift("StandardType");
    const worksheetData = [headers];

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate and download the Excel file
    XLSX.writeFile(workbook, `${selectedTemplate.Name}_template.xlsx`);
  };

  const getColumnsWithoutUserInput = (allColumns = []) => {
    const columns = [...allColumns];
    return columns.filter((x) => !x.DataType.startsWith("UserInput"));
  };

  const handleFileUpload = (e) => {
    const fileInputElement = document.createElement("input");
    fileInputElement.type = "file";
    fileInputElement.accept = ".xlsx, .xls";
    fileInputElement.multiple = false;

    // Handle the file upload when the user selects a file
    fileInputElement.addEventListener("change", (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0];
        const rows = jsonData.slice(1);
        const formattedData = rows.map((row) => {
          let obj = {};
          row.forEach((cell, index) => {
            obj[headers[index]] = cell;
          });
          return obj;
        });
        setRows(formattedData);
        // Clean up: remove the file input element from the DOM
        fileInputElement.remove();
      };

      // Read the file as a binary string
      reader.readAsBinaryString(file);
    });

    // Programmatically trigger the file input click
    fileInputElement.click();
  };

  const onDelete = (data) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .delete(api.api + "compoundCode/" + data._id, { data: data })
          .then((result) => {
            toast.success(`Deleted  Successfully`, {
              position: "bottom-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: "green", // Set your desired background color
                color: "white", // Set your desired text color
              },
            });
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              swal(`${err.response.data.message}`);
            } else {
              swal(`${err}`);
            }
            // toast.success(`${err}`, {
            //   position: 'bottom-right',
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   style: {
            //     background: 'red', // Set your desired background color
            //     color: 'white',     // Set your desired text color
            //   },
            // });
          });
      } else {
        // this.setState({ querySuccess: false });
        // swal("Your imaginary file is safe!");
      }
    });
  };

  const validateCheckCheckPoints = (rows = []) => {
    let errorObj = { IsError: false, message: [] };
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].StandardType == "Dimension") {
        const dimensionField = selectedTemplate.Columns.find(
          (x) => x.DataType == "StandardDimension"
        );
        if (dimensionField && !rows[i][dimensionField.DbFieldName]) {
          errorObj.IsError = true;
          errorObj.message.push(
            `Row Number ${i + 1} ${dimensionField.FieldName
            } is mandatory for Dimension Type check point.`
          );
          break;
        }
      }
    }
    return errorObj;
  };

  const handelSaveData = (data, AdjustedQty) => {
    console.log(data, "cvosjnvjnv", AdjustedQty);
    const checksheet = { ...AdjustedQty[0] };
    // delete checksheet.__v
    // delete checksheet.createdAt
    // delete checksheet.updatedAt
    // const errors = validation.validate(checksheet, schema);
    // if (errors) {
    //   seterrors(errors);
    //   return;
    // }
    checksheet["UniqueID"] = data.UniqueID;
    setLoader(true);
    if (opStatus == "update") {
      axios
        .post(api.api + "adjustInventory", checksheet)
        .then((result) => {
          swal("Data Update Successfully");
          // setQRCodeVisible(true);
          RawMatreialMaster();
          handleCloseModel();
          setAdjustedQty([]);
          setLoader(false);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    } else {
      axios
        .post(api.api + "RMDataEntry", Inputdata)
        .then((result) => {
          console.log(result, "cdisivbi");
          swal("Data Saved Successfully");
          // Split the QR codes into groups of 4
          setQRCodeVisible(true);
          const qrCodeGroups = [];
          const stickersPerPage = 16; // 4x4 grid on each page
          // if (QRCodeVisible) {
          const totalStickers = Number(NumOfPackings);
          // const stickersPerPage = 9; // 3x3 grid on each page
          for (let i = 0; i < totalStickers; i += stickersPerPage) {
            qrCodeGroups.push(
              [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
                (_, j) => i + j
              )
            );
          }
          // }
          if (qrCodeGroups.length > 0) {
            downloadPDF(qrCodeGroups, Inputdata);
          }
          // if(Result){
          handleCloseModel();
          // }
          RawMatreialMaster();
          setLoader(false);
          seterrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    }
  };
  const downloadPDFforAll = (data) => {
    const pdf = [];
    const EnableQr = [...data].filter((one) => one.Enable); // Filter objects where Enable is true

    console.log(`Downloading`, EnableQr);

    EnableQr.length > 0 &&
      EnableQr.map((one) =>
        [...Array(Math.min(one.NumberOfSheets))].forEach((_, j) => {
          pdf.push({
            QrCode: JSON.stringify({
              CompoundCode: one.CompoundCode,
              Batch: one.BatchCode,
              TotalQty: one.QtyProduced,
              MfgDate: new Date(one.DateOfMfg),
              UID: one.UniqueID,
              NSheets: one.NumberOfSheets,
              ExpiryDate: new Date(one.UseBy),
              Qty: one.Qty,
            }),

            index: j,
            UniqueID: one.UniqueID,
            CompoundCode: one.CompoundCode,
            batchCode: one.BatchCode,
            Location: one.Location,
            MfgDate: moment(one.DateOfMfg).format("DD-MM-YY"),
            Till_SrNo: one.Till_SrNo + j,
            From_SrNo: one.From_SrNo + j,
          });
        })
      );
    const qrCodeGroups = [];
    const stickersPerPage = 20; // 4x4 grid on each page
    // if (QRCodeVisible) {
    const totalStickers = Number(pdf.length);
    // const stickersPerPage = 9; // 3x3 grid on each page
    for (let i = 0; i < pdf.length; i += stickersPerPage) {
      qrCodeGroups.push(pdf.slice(i, i + stickersPerPage));
    }

    // }
    console.log("downloadPDF", data, pdf, qrCodeGroups);
    setmodelState1(true);
    SetQRCodeArray(qrCodeGroups);
  };

  const handelONaddSpare = (Date, Type, Quantity, Remarks) => {
    if (Date && Type && Quantity) {
      setAdjustedQty((prev) => [
        ...prev,
        { Date: Date, Type: Type, Qty: Quantity, Remarks: Remarks },
      ]);
    } else {
      swal("Please Fill Required Fields");
    }
    setDate("");
    setQuantity("");

    setType("");
    setRemarks("");
  };
  const handleClear = (data1, index) => {
    const data = [...AdjustedQty];
    if (index > -1) {
      // only splice array when item is found
      data.splice(index, 1); // 2nd parameter means remove one item only
    }
    setAdjustedQty(data);
  };
  return (
    <>
      {/* <div className='text-center'>
       
        <p>Checksheet Master</p>
      </div> */}
      {loader ? <Loading /> : <></>}

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState}
        onHide={handleHideModel}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            {/* <FontAwesomeIcon icon={faCircle} style={{color: "#0bd408",}} /> */}
            {/* {opStatus =='create' ?'Add':opStatus =='update'?'Update':'View'}  Activated Sheet QR{" "}
            {opStatus =='create' ?'': <div className="bg-success rounded">
              Available Qty : {Inputdata.Available_Qty}
            </div>} */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}
          <Row>
            {/* <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex ">
                <div className="w-25" htmlFor="operationRejectionCost">
                  RM Type
                </div>
                <div className="w-75">
                  <AntdSelect
                 disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                  placeholder="Select RM Type."
                  onChange={(value) => {
                    const template = templateList.find((x) => x.Name == value);
                    setSelectedTemplate(template || {});
                    handleOnChange({
                      currentTarget: { name: "RM_Type", value: value },
                    });
                  }}
                  value={Inputdata.RM_Type || []}
                  style={{ width: "100%" }}
                >
                  {templateList.map((one) => {
                    return (
                      <AntdSelect.Option value={one.Name}>
                        {one.Name}
                      </AntdSelect.Option>
                    );
                  })}
                </AntdSelect>
                  {/* <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="Test Report Number"
                    disabled={false}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="TestReportNo"
                    value={Inputdata.RM_Type}
                  /> */}
            {/* </div>

                {errors.RM_Type && (
                  <div className="alert small alert-danger">
                    {errors["RM_Type"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  RM ID
                </div>
                <div className="w-75">
                  <AntdSelect
                 disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                  placeholder="Select RM ID."
                  onChange={(value) => {
                    const template = templateList.find((x) => x.Name == value);
                    setSelectedTemplate(template || {});
                    handleOnChange({
                      currentTarget: { name: "RM_ID", value: value },
                    });
                  }}
                  value={Inputdata.RM_ID || []}
                  style={{ width: "100%" }}
                >
                  {RMIdList.map((one) => {
                    return (
                      <AntdSelect.Option value={one.Name}>
                        {one.Name}
                      </AntdSelect.Option>
                    );
                  })}
                </AntdSelect>
                  {/* <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="RM Id"
                    disabled={false}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="RM_ID"
                    value={Inputdata.RM_ID}
                  /> */}
            {/* </div>

                {errors.RM_ID && (
                  <div className="alert small alert-danger">
                    {errors["RM_ID"]}
                  </div>
                )}
              </div> */}
            {/* </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Vendor
                </div>
                <div className="w-75">
                  <AntdSelect
                disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                  placeholder="Select Vendor."
                  onChange={(value) => {
                    const template = templateList.find((x) => x.Name == value);
                    setSelectedTemplate(template || {});
                    handleOnChange({
                      currentTarget: { name: "Vendor", value: value },
                    });
                  }}
                  value={Inputdata.Vendor || []}
                  style={{ width: "100%" }}
                >
                  {VendorList.map((one) => {
                    return (
                      <AntdSelect.Option value={one.Name}>
                        {one.Name}
                      </AntdSelect.Option>
                    );
                  })}
                </AntdSelect>
                  {/* <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="RM Id"
                   disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="Vendor"
                    value={Inputdata.Vendor}
                  /> */}
            {/* </div>

                {errors.Vendor && (
                  <div className="alert small alert-danger">
                    {errors["Vendor"]}
                  </div>
                )}
              </div>
            </Col> */}
            {/* <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Invoice Date1
                </div>
                <div className="w-75">
                  <input
                    required
                    onChange={handleOnChange}
                   disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                    placeholder="Invoice Date1"
                    className="form-control form-control-sm"
                    type="date"
                    name="InvoiceDate"
                    value={
                      (Inputdata.InvoiceDate &&
                        Inputdata.InvoiceDate.split("T")[0]) ||
                      ""
                    }
                  />
                </div>

                {errors.InvoiceDate && (
                  <div className="alert small alert-danger">
                    {errors["InvoiceDate"]}
                  </div>
                )}
              </div>
            </Col>{" "}
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Invoice No
                </div>
                <div className="w-75">
                  <input
                    required
                   disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                    onChange={handleOnChange}
                    style={{ width: "100%" }}
                    //disabled={cycleTimeRadioState === 1 ? false : true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    placeholder="Invoice No"
                    name="InvoiceNo"
                    value={Inputdata.InvoiceNo}
                  />
                </div>

                {errors.InvoiceNo && (
                  <div className="alert small alert-danger">
                    {errors["InvoiceNo"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Recieved Qty
                </div>
                <div className="w-75">
                  <input
                    required
                   disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                    onChange={handleOnChange}
                    style={{ width: "100%" }}
                    //disabled={cycleTimeRadioState === 1 ? false : true}
                    className="form-control form-control-sm"
                    type="number"
                    // min="0"
                    placeholder="Recieved Qty"
                    name="ReceivedQty"
                    value={Inputdata.ReceivedQty}
                  />
                </div>

                {errors.ReceivedQty && (
                  <div className="alert small alert-danger">
                    {errors["ReceivedQty"]}
                  </div>
                )}
              </div>
            </Col> */}
            {/* <Col sm={12}> */}
            {/* <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Storage Location
                </div>
                <div className="w-75">
                  <AntdSelect
                disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                  placeholder="Select Storage Location."
                  onChange={(value) => {
                    const template = templateList.find((x) => x.Name == value);
                    setSelectedTemplate(template || {});
                    handleOnChange({
                      currentTarget: { name: "Location", value: value },
                    });
                  }}
                  value={Inputdata.Location || []}
                  style={{ width: "100%" }}
                >
                  {RMStorageList.map((one) => {
                    return (
                      <AntdSelect.Option value={one.Name}>
                        {one.Name}
                      </AntdSelect.Option>
                    );
                  })}
                </AntdSelect>
                  {/* <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="Storage Location"
                   disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="Location"
                    value={Inputdata.Location}
                  /> */}
            {/* </div>

                {errors.Location && (
                  <div className="alert small alert-danger">
                    {errors["Location"]}
                  </div>
                )}
              </div> */}
            {/* </Col>  */}
            {/* <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Test Report Number
                </div>
                <div className="w-75">
                  <input
                    required
                    onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="Test Report Number"
                   disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="TestReportNo"
                    value={Inputdata.TestReportNo}
                  />
                </div>

                {errors.TestReportNo && (
                  <div className="alert small alert-danger">
                    {errors["TestReportNo"]}
                  </div>
                )}
              </div>
            </Col> */}
            {/* <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                No. Of Packages
                </div>
                <div className="w-75">
                  <input
                    required
                    onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="No Of Packages"
                    disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="NumOfPackings"
                    value={Inputdata.NumOfPackings}
                  />
                </div>

                {errors.NumOfPackings && (
                  <div className="alert small alert-danger">
                    {errors["NumOfPackings"]}
                  </div>
                )}
              </div>
            </Col> */}
            <Col sm={12}>
              {opStatus == "create" ? (
                ""
              ) : (
                <Collapse defaultActiveKey={["1", "2"]} onChange={callback}>
                  <Panel header="Activated Green Sheet" key="2">
                    <Col sm={12}>
                      <div className="">
                        {opStatus === "view" ? (
                          ""
                        ) : (
                          <div className="d-flex  justify-content-between gap-2">
                            <div className="w-25">
                              <div className=" form-group text-center">
                                <div className="text-center ">Date </div>
                                <input
                                  required
                                  onChange={(e) => {
                                    setDate(e.currentTarget.value);
                                  }}
                                  disabled={opStatus === "view" ? true : false}
                                  placeholder="Invoice Date"
                                  className="form-control form-control-sm"
                                  type="date"
                                  name="Date"
                                  value={
                                    Date1
                                    //   &&
                                    //   Date1
                                    //   .split("T")[0]) ||
                                    // ""
                                  }
                                />
                              </div>
                            </div>
                            <div className="w-25">
                              <div className=" form-group text-center">
                                <div className="text-center ">
                                  Quantity{" "}
                                  {UnitOfMeasurment.length > 0 &&
                                    "(" + UnitOfMeasurment + ")"}
                                </div>

                                <input
                                  required
                                  onChange={(e) => {
                                    setQuantity(e.currentTarget.value);
                                  }}
                                  style={{ height: "30px" }}
                                  placeholder="Test Quantity"
                                  disabled={opStatus === "view" ? true : false}
                                  className="form-control form-control-sm m-0"
                                  type="number"
                                  // min="0"
                                  name="Qty"
                                  value={Quantity}
                                />
                              </div>
                            </div>
                            <div className="w-25">
                              <div className=" form-group text-center">
                                <div className="text-center ">Type </div>
                                <AntdSelect
                                  disabled={opStatus === "view" ? true : false}
                                  placeholder="Select Type"
                                  onChange={(value) => {
                                    setType(value);
                                  }}
                                  value={Type || ""}
                                  style={{ width: "100%" }}
                                >
                                  {["Add", "Reduce"].map((one) => {
                                    return (
                                      <AntdSelect.Option value={one}>
                                        {one}
                                      </AntdSelect.Option>
                                    );
                                  })}
                                </AntdSelect>
                              </div>
                            </div>

                            <div className="w-25">
                              <div className=" form-group text-center">
                                <div className="text-center ">Remarks </div>

                                <input
                                  type="text"
                                  placeholder="Remarks"
                                  name="Remarks"
                                  disabled={opStatus === "view" ? true : false}
                                  className="form-control form-control-sm"
                                  style={{ height: "30px" }}
                                  value={Remarks || ""}
                                  // Use remarksInput state if available, else use the Remarks from the checkpoint
                                  onChange={(e) => {
                                    setRemarks(e.currentTarget.value);
                                    if (Type && BatchCode) {
                                      let qty = spareList
                                        .filter(
                                          (item) => item.SparePartId === Type
                                        )[0]
                                        ?.Qty_Available_By_Batch.filter(
                                          (one) => one.BatchCode === BatchCode
                                        )[0].Qty;
                                      if (qty < e.currentTarget.value) {
                                        swal(
                                          "You can not exceed the batch Qty limit"
                                        );
                                      }
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {opStatus === "view" ? (
                          ""
                        ) : (
                          <button
                            className="btn-sm btn-success"
                            onClick={() =>
                              handelONaddSpare(
                                Date1,
                                Type,
                                Number(Quantity),
                                Remarks
                              )
                            }
                          >
                            + add
                          </button>
                        )}
                        <div className="">
                          <table className="table table-striped small table-bordered table-sm table-hover common my-1">
                            <thead className="small">
                              <tr className="table-primary text-center common-anchor">
                                <td>MFD</td>
                                <td>Activated Date</td>

                                <td>
                                  Two Roller Mixer{" "}
                                  {UnitOfMeasurment.length > 0 &&
                                    "(" + UnitOfMeasurment + ")"}{" "}
                                </td>
                                <td>Till SrNo</td>
                                <td>UniqueID</td>
                              </tr>
                            </thead>
                            <tbody>
                              {Inputdata.Activation &&
                                Inputdata.Activation.length > 0 &&
                                Inputdata.Activation.map((item) => (
                                  <tr className="text-center">
                                    <td
                                      style={{
                                        backgroundColor: `${item.Type == "Reduce"
                                            ? "#ffd6d2"
                                            : "#c9ffef"
                                          }`,
                                      }}
                                    >
                                      {moment(item.DateOfMfg).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${item.Type == "Reduce"
                                            ? "#ffd6d2"
                                            : "#c9ffef"
                                          }`,
                                      }}
                                    >
                                      {moment(item.ActivatedAt).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>

                                    <td
                                      style={{
                                        backgroundColor: `${item.Type == "Reduce"
                                            ? "#ffd6d2"
                                            : "#c9ffef"
                                          }`,
                                      }}
                                    >
                                      {item.MixingMill}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${item.Type == "Reduce"
                                            ? "#ffd6d2"
                                            : "#c9ffef"
                                          }`,
                                      }}
                                    >
                                      {item.Till_SrNo}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${item.Type == "Reduce"
                                            ? "#ffd6d2"
                                            : "#c9ffef"
                                          }`,
                                      }}
                                    >
                                      {item.UniqueID}
                                    </td>
                                  </tr>
                                ))}
                              {AdjustedQty.length > 0 &&
                                AdjustedQty.map((item, index) => (
                                  <tr className=" text-center">
                                    <td
                                      style={{
                                        backgroundColor: `${item.Type == "Reduce"
                                            ? "#ffd6d2"
                                            : "#c9ffef"
                                          }`,
                                      }}
                                    >
                                      {moment(item.Date).format("DD-MM-YYYY")}{" "}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${item.Type == "Reduce"
                                            ? "#ffd6d2"
                                            : "#c9ffef"
                                          }`,
                                      }}
                                    >
                                      {item.Qty}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${item.Type == "Reduce"
                                            ? "#ffd6d2"
                                            : "#c9ffef"
                                          }`,
                                      }}
                                    >
                                      {item.Type}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${item.Type == "Reduce"
                                            ? "#ffd6d2"
                                            : "#c9ffef"
                                          }`,
                                      }}
                                    >
                                      {item.Remarks}
                                    </td>
                                    {opStatus === "view" ? (
                                      ""
                                    ) : (
                                      <button
                                        className="btn-sm btn-danger "
                                        onClick={() => handleClear(item, index)}
                                      >
                                        x
                                      </button>
                                    )}
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      {/* {errors.ExpiryDate && (
                  <div className="alert small alert-danger">
                    {errors["ExpiryDate"]}
                  </div>
                )} */}
                    </Col>
                  </Panel>
                </Collapse>
              )}
            </Col>
            {/* <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex bg-success">
                <div className="w-25" htmlFor="operationRejectionCost">Available Qty</div >
                <div className="w-75">
                <input
                  required
                  onChange={handleOnChange}
                  style={{ width: "100%" }}
                  placeholder="Available Qty"
                  disabled={false}
                  className="form-control form-control-sm"
                  type="text"
                  // min="0"
                  name="Available"
                  value={Inputdata.Available_Qty}
                />
                </div>
                
                {errors.Available_Qty && (
                  <div className="alert small alert-danger">
                    {errors["Available_Qty"]}
                  </div>
                )}
              </div>
            </Col> */}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel()}>
            Close
          </Button>
          {opStatus === "view" ? (
            ""
          ) : (
            <Button
              variant="primary"
              onClick={() => {
                const error = validateCheckCheckPoints(rows);
                if (error.IsError) {
                  swal("ERROR", error.message.join(", "), { dangerMode: true });
                } else {
                  handelSaveData(Inputdata, AdjustedQty);
                }
              }}
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState1}
        onHide={handleHideModel1}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            Activated Sheet (QR)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}

          {console.log(Inputdata.NumOfPackings, "snsdonsdn")}
          <div className="a4-sheet">
            {
              QRCodeArray && QRCodeArray.length > 0 && (
                <div>
                  <Button
                    type="primary"
                    onClick={() => {
                      downloadPDF(QRCodeArray, Inputdata);
                      handleSetPrintTrue(PdfData);
                    }}
                    style={{ marginBottom: "16px" }}
                  >
                    Download as PDF
                  </Button>
                  <div
                    style={{ overflowY: "scroll", height: "72vh" }}
                    className=""
                  >
                    {QRCodeArray.map((group, idx) => (
                      <div className="a4-sheet-scrollable">
                        <div
                          className="a4-page"
                          // key={pageIndex}
                          style={{ pageBreakAfter: "always" }}
                        >
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: `repeat(${Math.sqrt(
                                16
                              )}, 1fr)`, // 3 columns in each row
                              gridTemplateRows: `repeat(${Math.sqrt(
                                16
                              )}, auto)`, // 3 rows per page (auto height)
                              gap: "57px", // Optional: Adjust the gap between items as needed
                              justifyItems: "center",
                              alignItems: "center",
                            }}
                          >
                            {group.map((one, index) => (
                              <div
                                className="d-flex flex-column justify-content-center align-items-center "
                                key={index}
                                style={{ textAlign: "center", marginBottom: '10px' }}
                              >
                                <QRCodeSVG
                                  value={one.QrCode}
                                  level={'M'}
                                  size={80}
                                  style={{ marginBottom: '3px' }}
                                />{" "}
                                {/* Adjust the size of the QR code */}
                                <p
                                  style={{
                                    fontSize: "9px",
                                    color: "black",
                                    letterSpacing: "0.5px",
                                    lineHeight: "1.2",
                                  }}
                                  className="bolder p-0 m-0"
                                >
                                  {one.UniqueID}
                                  <br />
                                  {one.batchCode} / {one.CompoundCode}
                                  <br />

                                  {one.MfgDate} /{` Sheet-#${one.From_SrNo}`}
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )
              // [...Array(Number(Inputdata.NumOfPackings))].map((_, index) => (
              //   <Space className="qr-space" key={index} direction="vertical" align="center">
              //     <QRCodeSVG value={JSON.stringify(Inputdata)} size={100} />
              //     <p>{index + 1 + ' / ' + Inputdata.NumOfPackings}</p>
              //   </Space>
              // ))
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel1()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {
        // <button
        //   disabled={!getRightsForAccess("DynamicDataRights", RightName, "write")}
        //   className="btn-sm btn-primary float-right"
        //   onClick={() => {
        //     setQRCodeVisible(false);
        //     setmodelState(true);
        //     setInputData({});
        //     setUpdate({});
        //     setSelectedTemplate({});
        //     setopStatus('create')
        //   }}
        // >
        //   Add Inventory
        // </button>
      }
      {/* <button type="button" className="btn-sm btn-primary  mx-2" 
    // onClick={()=>handleUploadGuagesDoc()}
    >
      <FontAwesomeIcon icon={faFileImport} /> Import Excel</button> */}
      {/* {getRightsForAccess('DynamicDataRights', RightName, "write") && <Excelimport />} */}

      <div className="row">
        <div className="col-sm-2">
          <div className="form-group">
            <label className="small m-0">From</label>
            <input
              value={moment(inputData.From).format("YYYY-MM-DD")}
              className="form-control form-control-sm"
              onChange={(e) => handleOnChange("From", e.currentTarget.value)}
              type="date"
            />
          </div>
        </div>
        <div className="col-sm-2">
          <div className="form-group">
            <label className="small m-0">Till</label>
            <input
              value={moment(inputData.Till).format("YYYY-MM-DD")}
              className="form-control form-control-sm"
              onChange={(e) => handleOnChange("Till", e.currentTarget.value)}
              type="date"
            />
          </div>
        </div>

        <div className="col-sm-3">
          <div className="form-group">
            <label className="small m-0">Sticker Printed</label>
            <AntdSelect
              placeholder={"Print Type"}
              onChange={(value) => {
                console.log(value, "wkhbkfwifiwe");
                handleOnChange("PrintType", value);
              }}
              value={`${inputData.PrintType == true ? 'Yes' : inputData.PrintType == false ? 'No' : 'All'}` || ""}
              style={{ width: "100%" }}
            >
              {[
                { Name: "All", value: "All" },
                { Name: "Yes", value: true },
                { Name: "No", value: false },
              ].map((one) => {
                return (
                  <AntdSelect.Option key={one.value} value={one.value}>
                    {`${one.Name}`}
                  </AntdSelect.Option>
                );
              })}
            </AntdSelect>
          </div>
        </div>

        <div className="col-sm-1">
          <button
            className="btn btn-primary btn-sm mt-4"
            onClick={() => handleGetData()}
          >
            Apply
          </button>
        </div>
      </div>

      {PdfData && PdfData.length > 0 && EnableAllPdf && (
        <button
          type="button"
          className="btn-sm btn-primary"
          onClick={() => downloadPDFforAll(PdfData)}
        >
          Activated Sheet (pdf)
        </button>
      )}

      {RawMaterialData.length < 0 ? (
        "Data Not Available"
      ) : (
        <Table
          columns={columns}
          onSort={handleSort}
          sortColumn={sortColumn}
          data={RawMaterialData}
        />
      )}
    </>
  );
};

export default DisPatch_Section;
